import { Flex } from '@chakra-ui/react';
import * as React from 'react';
import { DropzoneInputProps, useDropzone } from 'react-dropzone';

import { CsvFileDropTextContent } from './CsvFileDropTextContent';

export type ICsvFileDropProps = {
  file: File | null;
  onFileChange: (file: File | null) => void;
  hasLoadingSideEffect?: boolean;
  onRemoveFile: (e: React.SyntheticEvent) => void;
};

export const CsvFileDrop: React.FC<ICsvFileDropProps> = (props) => {
  const onDrop = (acceptedFiles: File[]): void => {
    const file = acceptedFiles && acceptedFiles.length > 0 && acceptedFiles[0];
    if (!file) {
      props.onFileChange(null);
      return;
    }

    props.onFileChange(file);
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: '.csv',
  });
  const { ref, ...rootProps } = getRootProps();

  return (
    <Flex
      h="3xs"
      align="center"
      direction="column"
      justify={!!props.file ? 'flex-start' : 'center'}
      bg="gray.100"
      borderRadius="xl"
      p="2"
      {...(rootProps as typeof rootProps & { style: React.CSSProperties })}
    >
      <CsvFileDropTextContent
        showLoader={props.hasLoadingSideEffect}
        isDragActive={isDragActive}
        uploadedFileName={props?.file?.name}
        onRemoveFile={props.onRemoveFile}
      />
      <input
        {...(getInputProps({ multiple: false }) as DropzoneInputProps & {
          style: React.CSSProperties;
        })}
      />
    </Flex>
  );
};
